import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarDialogService } from '../../../../components/calendar-dialog/calendar-dialog.service';
import { CalendarScreenModule } from '../../../../components/calendar-screen/calendar-screen.module';
import { CalendarSubChromeModule } from '../../../../components/calendar-screen/calendar-sub-chrome/calendar-sub-chrome.module';
import { CalendarWrapperComponent } from './calendar-wrapper.component';
import { WidgetsModule } from '../../../../widgets/widgets.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        CalendarSubChromeModule,
        CalendarScreenModule
    ],
    declarations: [
        CalendarWrapperComponent
    ],
    exports: [
        CalendarWrapperComponent
    ],
    providers: [
        CalendarDialogService
    ]
})
export class CalendarWrapperModule {

}
